import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthApi } from '../api/resources';
import { ApiError } from '../api/client';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

export function Profile() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const { notify } = useToast();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving, setSaving] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      notify('La confirmacion no coincide con la nueva contraseña.', 'error');
      return;
    }
    setSaving(true);
    try {
      await AuthApi.changePassword(currentPassword, newPassword);
      notify('Contraseña actualizada correctamente.', 'success');
      await refresh();
      navigate('/', { replace: true });
    } catch (err) {
      notify(err instanceof ApiError ? err.message : 'No fue posible actualizar la contraseña.', 'error');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div>
      <h1>Mi cuenta</h1>
      <div className="card">
        <h2>Datos de la cuenta</h2>
        <p>
          <strong>Nombre:</strong> {user?.fullName}
        </p>
        <p>
          <strong>Usuario:</strong> {user?.username}
        </p>
        <p>
          <strong>Correo:</strong> {user?.email}
        </p>
        <p>
          <strong>Rol:</strong> {user?.role === 'ADMIN' ? 'Administrador' : 'Empleado'}
        </p>
      </div>

      <div className="card" id="cambiar-clave">
        <h2>Cambiar clave</h2>
        {user?.mustResetPassword && (
          <div className="alert alert-info" role="status">
            Tu cuenta tiene una clave temporal. Ingrésala como clave actual y define una nueva.
          </div>
        )}
        <form onSubmit={handleSubmit} noValidate>
          <div className="field">
            <label htmlFor="currentPassword">Clave actual (o clave temporal)</label>
            <input id="currentPassword" type="password" required autoComplete="current-password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} />
          </div>
          <div className="field">
            <label htmlFor="newPassword">Nueva contraseña</label>
            <input id="newPassword" type="password" required minLength={8} autoComplete="new-password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
            <span className="hint">Minimo 8 caracteres.</span>
          </div>
          <div className="field">
            <label htmlFor="confirmPassword">Confirmar nueva contraseña</label>
            <input id="confirmPassword" type="password" required autoComplete="new-password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
          </div>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? 'Guardando...' : 'Cambiar clave'}
          </button>
        </form>
      </div>
    </div>
  );
}
